import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { CircularDial } from '../CircularDial';
import { VideoModal } from '../common/VideoModal';
import { IMAGE_PATHS } from '@/utils/images';

export const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          className="glass p-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="text-center lg:text-left">
              <motion.h1 
                className="text-4xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-[#84F8B6] via-[#ABF0FF] to-[#A495FF] bg-clip-text text-transparent mb-4"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
              >
                Your Life,<br />
                Optimized
              </motion.h1>
              <motion.p 
                className="text-lg text-gray-400 mb-8"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
              >
                Track, analyze, and optimize every aspect of your life with our comprehensive life management platform.
              </motion.p>
              <motion.div 
                className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-4"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                <button 
                  onClick={() => navigate('/signups')}
                  className="px-8 py-3 bg-[#84F8B6] text-black rounded-lg font-medium hover:bg-[#84F8B6]/90 transition-colors flex items-center space-x-2"
                >
                  <span>Join the Beta</span>
                  <span>→</span>
                </button>
                <button 
                  onClick={() => setShowVideo(true)}
                  className="px-8 py-3 bg-[#2D2B42] text-[#A495FF] rounded-lg font-medium hover:bg-[#2D2B42]/90 transition-colors flex items-center justify-center space-x-2"
                >
                  <Play className="w-4 h-4" />
                  <span>Watch Video</span>
                </button>
              </motion.div>
            </div>
            <div className="flex justify-center w-full max-w-[300px] lg:max-w-none mx-auto">
              <CircularDial value={9.2} maxValue={10} label="LIFE SCORE" />
            </div>
          </div>
        </motion.div>
      </div>

      <VideoModal
        isOpen={showVideo}
        onClose={() => setShowVideo(false)}
        videoUrl="/images/corporategirl.mp4"
      />
    </>
  );
};